import { api } from "../../api/apiSlice";

// Reference/catalog data (handoff §6) - feeds dropdowns and the permission
// checklist on the Role, Designation, and User screens. Any logged-in user
// can read these; the screens that act on them are separately permission-gated.
export const adminApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getModules: builder.query({
      query: () => ({ url: "/admin/modules" }),
      providesTags: ["AdminCatalog"],
    }),
    getPermissions: builder.query({
      query: () => ({ url: "/admin/permissions" }),
      providesTags: ["AdminCatalog"],
    }),
    getBranches: builder.query({
      query: () => ({ url: "/admin/branches" }),
      providesTags: ["AdminCatalog"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetModulesQuery,
  useGetPermissionsQuery,
  useGetBranchesQuery,
} = adminApi;
